import * as React from 'react';

import { useDeviceCondition } from '../../../../../../hooks';
import * as styles from './Layout.css';

interface ILayoutProps {
  price: React.ReactNode;
  packages: React.ReactNode;
  recommendedPackages: React.ReactNode;
  recommendedPackagePaymentStatus: React.ReactNode;
  restrictions: React.ReactNode;
}

export const Layout = ({
  price,
  packages,
  recommendedPackages,
  recommendedPackagePaymentStatus,
  restrictions,
}: ILayoutProps) => {
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  if (restrictions) {
    return <div className={rootStyle}>{restrictions}</div>;
  }

  return (
    <div className={rootStyle}>
      <div className={styles['publication']}>{price}</div>

      {packages && <div className={styles['packages']}>{packages}</div>}

      {recommendedPackages}

      {recommendedPackagePaymentStatus}
    </div>
  );
};
